import { connect } from '@ardoq/rxbeach';
import {
  ComponentStylePreview as ComponentStylePreviewSVG,
  ComponentStylePreviewArgs,
} from '@ardoq/metamodel-editor';
import { componentStylePreview$ } from 'appModelStateEdit/propertiesEditor/componentStylePreview/componentStylePreview$';

const ComponentStylePreviewBase = ({
  icon,
  image,
  shape,
  color,
  labels,
}: ComponentStylePreviewArgs) => {
  return (
    <ComponentStylePreviewSVG
      icon={icon}
      image={image}
      shape={shape}
      color={color}
      labels={labels}
    />
  );
};

export const ComponentStylePreview = connect(
  ComponentStylePreviewBase,
  componentStylePreview$
);
